import * as React from 'react';

import Snackbar from 'components/Snackbar/Snackbar.jsx';

const { Consumer, Provider } = React.createContext({});

export const SnackbarConsumer = Consumer;

export class SnackbarProvider extends React.Component {
  state = { queue: [], current: undefined };

  snackbarTimer = 0;

  componentWillUnmount() {
    clearTimeout(this.snackbarTimer);
  }

  addNotification = (type, text) => {
    this.setState(prevState => {
      if (prevState.current) {
        return prevState.queue.concat({ type, text });
      } else {
        return { current: { type, text } };
      }
    });
    this.autoCloseSnackbar();
  };

  autoCloseSnackbar = () => {
    this.snackbarTimer = setTimeout(() => {
      this.removeNotification();
    }, 3000);
  };

  removeNotification = () => {
    clearTimeout(this.snackbarTimer);
    this.setState(prevState => {
      if (prevState.queue.length) {
        const queue = [...prevState.queue];
        const current = queue.shift();
        return { queue, current };
      }
      return { current: undefined };
    });
  };

  render() {
    const { current } = this.state;
    return (
      <Provider value={this.addNotification}>
        {this.props.children}
        {current ? (
          <Snackbar
            place="tr"
            color={current.type}
            message={current.text}
            open
            close
            closeNotification={() => this.removeNotification()}
          />
        ) : null}
      </Provider>
    );
  }
}
export const withSnackbar = Component => props => (
  <Consumer>
    {addNotification => (
      <Component {...props} addNotification={addNotification} />
    )}
  </Consumer>
);



// WEBPACK FOOTER //
// ./src/views/snackbar/SnackbarContext.jsx